export enum AccountTabName {
	Orders = "Orders",
	Invoices = "Invoices",
	Billing = "Billing",
	Alerts = "Alerts",
	Account = "Account",
}

export type AccountUrlState = {
	tab: AccountTabName
	from?: "checkout" | null // We might be directed here from checkout
}
